import select2 from 'select2';

export default function initializeForms() {
    addStylesToCheckboxes();
    initializeFormSelects();
}

function addStylesToCheckboxes() {
    const labels = document.querySelectorAll('.wpcf7-list-item > label, .tnp-privacy-field label');

    labels.forEach(label => {
        label.addEventListener('click', e => {
            let checkbox = label.querySelector('input[type="checkbox"]');

            if (checkbox.checked === true) {
                label.classList.add('checked');
            } else {
                label.classList.remove('checked');
            }
        });
    });

    document.querySelectorAll('.wpcf7').forEach(function (form) {
        form.addEventListener('wpcf7mailsent', function (e) {
            event.currentTarget.querySelectorAll('input[type="checkbox"], input[type="radio"]').forEach(function (select) {
                select.closest('label').classList.remove('checked');
            });
        })
    });
}

function initializeFormSelects() {
    $('.wpcf7-select').each(function () {
        $(this).select2({
            language: $('body').data('lang'),
            minimumResultsForSearch: Infinity,
            dropdownParent: $(this).closest('.form__element')
        });
    });

    $('.tnp-language').each(function () {
        $(this).select2({
            language: $('body').data('lang'),
            minimumResultsForSearch: Infinity,
            dropdownParent: $(this).closest('.tnp-field-language')
        });
    });
}